import Header from "components/Common/Header/Header";
import HeadCircumferenceBody from "components/PatientManagement/Vital/HeadCircumference/HeadCircumferenceBody";
import React, { useEffect } from "react";

const HeadCircumference = () => {
  useEffect(() => {
    document.title = "Vitals | Head Circumference";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <HeadCircumferenceBody />
    </main>
  );
};

export default HeadCircumference;
